(() => {
  const controllers = new Map();

  function initialise() {
    document.querySelectorAll('[data-bab-desktop-layout]').forEach((root) => {
      if (controllers.has(root)) return;
      const contents = root.querySelector('.product-bundle__contents');
      const size = root.querySelector('.build-a-bundle__size');
      const total = root.querySelector('.build-a-bundle__total');
      const cta = root.querySelector('.build-a-bundle__add-to-cart');
      const frequency = root.querySelector('.build-a-bundle__frequency');
      const bar = root.querySelector('[data-bab-desktop-purchase]');
      if (!contents || !size || !total || !cta || !frequency || !bar) return;
      const copy = JSON.parse(root.querySelector('[data-bab-desktop-copy]').textContent);
      const mq = window.matchMedia('(min-width: 1025px)');
      const originalCheckout = contents.getAttribute('data-straight-to-checkout');
      const dialog = root.querySelector('[data-bab-box-dialog]');
      const viewBox = root.querySelector('[data-bab-view-box]');
      const boxAction = dialog?.querySelector('[data-bab-box-action]');
      const boxActionText = boxAction?.querySelector('[data-bab-box-action-text]');
      const keepChoosing = boxActionText?.textContent;
      const rows = new Map();
      const boxTemplate = dialog?.querySelector('[data-bab-box-item-template]');
      const nutritionDialog = root.querySelector('[data-bab-nutrition-dialog]');
      const nutritionImage = nutritionDialog?.querySelector('[data-bab-nutrition-image]');
      let nutritionTrigger = null;
      const flavoursHeading = root.querySelector('.bab-desktop-flavours-heading');
      const labelText = cta.querySelector('[data-bab-desktop-cta-text]');
      let frame = 0;
      let inView = true;
      const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
      const setAttribute = (node, name, value) => { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); };
      const countNodes = root.querySelectorAll('[data-bab-desktop-count]');
      const progressCount = root.querySelector('.build-a-bundle__progress-bar-count-current');
      const sizeGroup = size.querySelector('.build-a-bundle__size-buttons');
      const sizeButtons = Array.from(sizeGroup.querySelectorAll('.build-a-bundle__size-button'));
      const frequencyButtons = frequency.querySelectorAll('.build-a-bundle__type-subscription');
      const frequencyGroups = frequency.querySelectorAll('.build-a-bundle__frequency-buttons');
      const meters = [bar.querySelector('[role="progressbar"]'), root.querySelector('.bab-desktop-flavour-meter')].filter(Boolean);
      const meterFills = meters.map((progress) => progress.querySelector('span'));
      const subscriptionPrice = total.querySelector('.build-a-bundle__price-subscription');
      const normalPrice = total.querySelector('.build-a-bundle__price-normal');
      const boxList = dialog?.querySelector('[data-bab-box-items]');
      const boxEmpty = dialog?.querySelector('[data-bab-box-empty]');
      const boxTotal = dialog?.querySelector('[data-bab-box-total]');
      const boxGift = dialog?.querySelector('[data-bab-box-gift]');
      const boxGiftImage = boxGift?.querySelector('img');
      const potImage = size.querySelector('.build-a-bundle__size-gift-img');
      const boxClose = dialog?.querySelector('[data-bab-box-close]');
      const nutritionProduct = nutritionDialog?.querySelector('[data-bab-nutrition-product]');
      const nutritionLoading = nutritionDialog?.querySelector('[data-bab-nutrition-loading]');
      const nutritionError = nutritionDialog?.querySelector('[data-bab-nutrition-error]');
      const cards = Array.from(root.querySelectorAll('.build-a-bundle__collection.mobile .bundle-card'), (card) => ({
        input: card.querySelector('.bundle-card__quantity-input'),
        image: card.querySelector('.build-a-bundle__collection-group-product-img'),
        minus: card.querySelector('.bundle-card__quantity-minus'),
        plus: card.querySelector('.bundle-card__quantity-plus')
      }));
      const selectedSize = () => Number(sizeButtons.find((button) => button.classList.contains('active'))?.dataset.size) || 6;
      const selectedCount = () => Number(progressCount?.textContent.trim()) || 0;

      function openNutrition(button) {
        const { nutritionUrl, nutritionTitle, nutritionAlt, nutritionWidth, nutritionHeight } = button.dataset;
        if (!nutritionUrl || !nutritionDialog || nutritionDialog.open) return;
        nutritionTrigger = button;
        setText(nutritionProduct, nutritionTitle);
        nutritionImage.hidden = true;
        nutritionLoading.hidden = false;
        nutritionError.hidden = true;
        nutritionImage.alt = nutritionAlt;
        nutritionImage.width = nutritionWidth;
        nutritionImage.height = nutritionHeight;
        nutritionImage.src = nutritionUrl;
        nutritionDialog.showModal();
        if (nutritionImage.complete && nutritionImage.naturalWidth) onNutritionLoad();
      }
      function onNutritionLoad() {
        nutritionImage.hidden = false;
        nutritionLoading.hidden = true;
        nutritionError.hidden = true;
      }
      function onNutritionError() {
        nutritionImage.hidden = true;
        nutritionLoading.hidden = true;
        nutritionError.hidden = false;
      }
      function closeNutrition() { if (nutritionDialog?.open) nutritionDialog.close(); }
      function onNutritionClose() {
        if (nutritionTrigger?.isConnected) nutritionTrigger.focus();
      }
      function onNutritionClick(event) {
        if (event.target.closest('[data-bab-nutrition-close]')) closeNutrition();
        if (event.target === nutritionDialog) {
          const rect = nutritionDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeNutrition();
        }
      }

      function restoreCheckout() {
        contents.setAttribute('data-straight-to-checkout', originalCheckout);
      }

      function syncBox(max, current) {
        if (!dialog?.open) return;
        const selected = new Set();
        cards.forEach(({ input, image, minus: nativeMinus, plus: nativePlus }) => {
          const quantity = Number(input?.value) || 0;
          if (!quantity || !input || selected.has(input.dataset.variantId)) return;
          const id = input.dataset.variantId;
          selected.add(id);
          let row = rows.get(id);
          if (!row) {
            if (!boxTemplate) return;
            const item = boxTemplate.content.firstElementChild.cloneNode(true);
            const title = input.dataset.productTitle;
            item.querySelector('img').src = image.currentSrc || image.src;
            setText(item.querySelector('[data-bab-box-item-title]'), title);
            setText(item.querySelector('[data-bab-box-item-serving]'), input.dataset.serving);
            const value = item.querySelector('[data-bab-box-item-quantity]');
            const minus = item.querySelector('[data-bab-box-minus]');
            const plus = item.querySelector('[data-bab-box-plus]');
            minus.setAttribute('aria-label', copy.removeItem.replace('[product]', title));
            plus.setAttribute('aria-label', copy.addItem.replace('[product]', title));
            minus.addEventListener('click', () => nativeMinus?.click());
            plus.addEventListener('click', () => nativePlus?.click());
            boxList.appendChild(item);
            row = { item, value, plus };
            rows.set(id, row);
          }
          setText(row.value, String(quantity));
          row.plus.disabled = current >= max;
        });
        rows.forEach((row, id) => {
          if (selected.has(id)) return;
          const heldFocus = row.item.contains(document.activeElement);
          row.item.remove(); rows.delete(id);
          if (heldFocus) boxClose.focus();
        });
        boxEmpty.hidden = selected.size > 0;
        const subscription = contents.dataset.purchaseType === 'subscription';
        dialog.dataset.complete = String(current === max);
        dialog.dataset.purchaseType = contents.dataset.purchaseType;
        setText(boxActionText, current === max ? (subscription ? copy.checkout : copy.addToCart) : keepChoosing);
        const price = subscription ? subscriptionPrice : normalPrice;
        setText(boxTotal, price?.textContent.trim() || '');
        boxGift.hidden = !(subscription && [6, 8, 10].includes(max));
        if (potImage) setAttribute(boxGiftImage, 'src', potImage.getAttribute('src'));
      }

      function openBox() {
        if (!mq.matches || !dialog || dialog.open || viewBox.hidden) return;
        dialog.showModal();
        viewBox.setAttribute('aria-expanded', 'true');
        if (frame) cancelAnimationFrame(frame);
        sync();
      }
      function closeBox() { if (dialog?.open) dialog.close(); }
      function onBoxClose() {
        viewBox?.setAttribute('aria-expanded', 'false');
        if (mq.matches) {
          if (viewBox && !viewBox.hidden) viewBox.focus();
          else flavoursHeading?.focus();
        }
      }
      function onDialogClick(event) {
        if (event.target.closest('[data-bab-box-action]')) {
          const max = selectedSize();
          const current = selectedCount();
          closeBox();
          if (current === max && !cta.disabled) cta.click();
          return;
        }
        if (event.target.closest('[data-bab-box-close]')) closeBox();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeBox();
        }
      }

      function sync() {
        frame = 0;
        if (!mq.matches) return;
        const max = selectedSize();
        const current = selectedCount();
        const remaining = Math.max(0, max - current);
        const ready = current === max;
        if (viewBox) viewBox.hidden = current === 0;
        countNodes.forEach((node) => setText(node, `${current} / ${max} ${copy.packsAdded}`));
        const progressWidth = `${Math.min(100, current / max * 100)}%`;
        meters.forEach((progress) => {
          setAttribute(progress, 'aria-valuemax', String(max));
          setAttribute(progress, 'aria-valuenow', String(current));
        });
        meterFills.forEach((fill) => {
          if (fill && fill.style.width !== progressWidth) fill.style.width = progressWidth;
        });
        setAttribute(bar, 'data-complete', String(ready));
        const subscription = contents.dataset.purchaseType === 'subscription';
        setAttribute(bar, 'data-purchase-type', contents.dataset.purchaseType);
        setAttribute(contents, 'data-straight-to-checkout', String(subscription));
        setText(labelText, ready ? (subscription ? copy.checkout : copy.addToCart) : current > max ? (current - max === 1 ? copy.removeOne : copy.removeMore.replace('[count]', String(current - max))) : remaining === 1 ? copy.addOne : copy.addMore.replace('[count]', String(remaining)));
        syncBox(max, current);
        sizeButtons.forEach((button) => {
          const active = button.classList.contains('active');
          setAttribute(button, 'role', 'radio');
          setAttribute(button, 'aria-checked', String(active));
          setAttribute(button, 'tabindex', active ? '0' : '-1');
        });
        setAttribute(sizeGroup, 'role', 'radiogroup');
        setAttribute(sizeGroup, 'aria-label', copy.box);
        frequencyButtons.forEach((button) => {
          setAttribute(button, 'aria-pressed', String(button.classList.contains('active')));
        });
        bar.classList.toggle('is-visible', inView && current > 0);
      }
      function scheduleSync() { if (mq.matches && !frame) frame = requestAnimationFrame(sync); }

      function onViewportChange() {
        observer.disconnect();
        visibility.disconnect();
        if (frame) { cancelAnimationFrame(frame); frame = 0; }
        if (mq.matches) {
          observer.observe(contents, { attributes: true, attributeFilter: ['data-purchase-type'] });
          observer.observe(sizeGroup, { subtree: true, attributes: true, attributeFilter: ['class'] });
          frequencyGroups.forEach((group) => observer.observe(group, { subtree: true, attributes: true, attributeFilter: ['class'] }));
          [progressCount, subscriptionPrice, normalPrice].filter(Boolean).forEach((node) => observer.observe(node, { childList: true, characterData: true, subtree: true }));
          visibility.observe(root);
          scheduleSync();
        } else {
          if (selectedSize() === 10) sizeButtons.find((button) => Number(button.dataset.size) === 8)?.click();
          closeBox();
          restoreCheckout();
          bar.classList.remove('is-visible');
          giftButtons.forEach((button) => button.classList.add('subscription-gift'));
          size.querySelectorAll('[role="radio"]').forEach((button) => {
            button.removeAttribute('role');
            button.removeAttribute('aria-checked');
            button.removeAttribute('tabindex');
          });
          const group = size.querySelector('[role="radiogroup"]');
          group?.removeAttribute('role');
          group?.removeAttribute('aria-label');
        }
      }

      function onClick(event) {
        if (!(event.target instanceof Element)) return;
        const nutritionButton = event.target.closest('[data-bab-nutrition-button]');
        if (nutritionButton) { openNutrition(nutritionButton); return; }
        if (event.target.closest('.bundle-card__quantity, .build-a-bundle__quick-bundle-add')) scheduleSync();
      }
      function onKey(event) {
        if (!mq.matches) return;
        const radio = event.target.closest?.('.build-a-bundle__size-button');
        if (!radio || !size.contains(radio)) return;
        if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); radio.click(); }
        const buttons = sizeButtons;
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 0;
        if (direction) {
          event.preventDefault();
          const next = buttons[(buttons.indexOf(radio) + direction + buttons.length) % buttons.length];
          next.click();
          (size.querySelector('.active') || radio).focus();
        }
      }
      const giftButtons = Array.from(root.querySelectorAll('.build-a-bundle__type-button--subscribe.subscription-gift'));
      function beforePurchase() {
        if (!mq.matches) return;
        contents.dataset.straightToCheckout = String(contents.dataset.purchaseType === 'subscription');
        const selected = selectedSize();
        const eligible = contents.dataset.purchaseType === 'subscription' && [6, 8, 10].includes(selected);
        contents.dataset.babGiftEligible = String(eligible);
        giftButtons.forEach((button) => button.classList.toggle('subscription-gift', eligible));
      }

      const observer = new MutationObserver(scheduleSync);
      const visibility = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        bar.classList.toggle('is-visible', mq.matches && inView && selectedCount() > 0);
      }, { rootMargin: '-120px 0px 0px 0px' });
      root.addEventListener('click', onClick);
      root.addEventListener('keydown', onKey);
      cta.addEventListener('click', beforePurchase, true);
      viewBox?.addEventListener('click', openBox);
      dialog?.addEventListener('click', onDialogClick);
      dialog?.addEventListener('close', onBoxClose);
      nutritionDialog?.addEventListener('click', onNutritionClick);
      nutritionDialog?.addEventListener('close', onNutritionClose);
      nutritionImage?.addEventListener('load', onNutritionLoad);
      nutritionImage?.addEventListener('error', onNutritionError);
      mq.addEventListener('change', onViewportChange);
      onViewportChange();
      controllers.set(root, () => {
        observer.disconnect(); visibility.disconnect();
        if (frame) cancelAnimationFrame(frame);
        root.removeEventListener('click', onClick);
        root.removeEventListener('keydown', onKey);
        cta.removeEventListener('click', beforePurchase, true);
        viewBox?.removeEventListener('click', openBox);
        dialog?.removeEventListener('click', onDialogClick);
        dialog?.removeEventListener('close', onBoxClose);
        nutritionDialog?.removeEventListener('click', onNutritionClick);
        nutritionDialog?.removeEventListener('close', onNutritionClose);
        nutritionImage?.removeEventListener('load', onNutritionLoad);
        nutritionImage?.removeEventListener('error', onNutritionError);
        closeNutrition();
        closeBox(); restoreCheckout();
        mq.removeEventListener('change', onViewportChange);
        controllers.delete(root);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
